// extracted by mini-css-extract-plugin
export default {"purchaseBtn":"WebxpayDepositWallet_purchaseBtn__AK-nd"};